window.Clipboard = (function (window, document, navigator) {
  var textArea;
  var copy;

  function isIOS() {
    return navigator.userAgent.match(/ipad|iphone/i);
  }

  function createTextArea(text) {
    textArea = document.createElement('textArea');
    textArea.readOnly = true;
    textArea.value = text;
    document.body.appendChild(textArea);
  }

  function selectText() {
    var range;
    var selection;

    if (isIOS()) {
      range = document.createRange();
      range.selectNodeContents(textArea);
      selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      textArea.setSelectionRange(0, 999999);
    } else {
      textArea.select();
    }
  }

  function copyToClipboard() {
    document.execCommand('copy');
    document.body.removeChild(textArea);
  }

  copy = function (text) {
    createTextArea(text);
    selectText();
    copyToClipboard();
  };

  return {
    copy: copy,
  };
})(window, document, navigator);

export default angular
  .module('doxy.common.directives.dCopy', [])
  .directive('dCopy', function ($timeout) {
    return {
      scope: {
        target: '@',
        copySuccess: '&copySuccess',
        copyError: '&copyError',
      },
      link: function (scope, element) {
        function start() {
          element.attr({ disabled: true });
          element.addClass('button--progress');
        }

        function stop() {
          element.removeClass('button--progress');
          element.addClass('button--success');
          $timeout(() => {
            element.removeClass('button--success');
            element.attr({ disabled: false });
          }, 1000);
        }

        element[0].addEventListener('click', () => {
          start();
          const el = document.querySelector(scope.target);
          window.Clipboard.copy(el.value || el.textContent);
          $timeout(() => {
            stop();
          }, 250);
          scope.$apply(scope.copySuccess);
        });
      },
    };
  }).name;
